import { PageResponse } from '@payer-admin-ui/api/src/utils/repository/PageResponse';
import { InvoiceAggregationNumberObject } from '@payer-admin-ui/components-v2/src/types/state';
import { GetInvoiceStatementBasicsResponse } from '@payer-admin-ui/api/src/ui/invoicestatements/responses/GetInvoiceStatementBasicsResponse';
import { DeliveryType } from '@payer-admin-ui/api/src/invoices/models/DeliveryType';
import { GetInvoiceStatementDetailsResponse } from '@payer-admin-ui/api/src/ui/invoicestatements/responses/GetInvoiceStatementDetailsResponse';
import { wrappedApiGet, wrappedApiPut } from '../utils/http';
import { InvoiceAggregationsFilters } from '../views/Pages/invoiceAggregations/invoiceAggregationsGlobalState';
import { InvoiceAggregationDetailsResponse } from '../views/Pages/invoiceAggregations/models/InvoiceAggregationDetailsResponse';

export const invoiceAggregationAPI = {
  fetchPage: ({
    page,
    pageSize,
    appliedFilters,
    sort,
  }: {
    page: number;
    pageSize: number;
    appliedFilters: InvoiceAggregationsFilters;
    sort: string[];
  }): Promise<PageResponse<GetInvoiceStatementBasicsResponse>> => {
    return wrappedApiGet<PageResponse<GetInvoiceStatementBasicsResponse>>(`/invoice-aggregations`, {
      query: {
        offset: page * pageSize,
        pageSize,
        ...appliedFilters,
        sort,
      },
    }).withObjectResponse();
  },
  fetchDetails: ({
    invoiceAggregationNumber,
  }: InvoiceAggregationNumberObject): Promise<GetInvoiceStatementDetailsResponse> => {
    return wrappedApiGet<GetInvoiceStatementDetailsResponse>(
      `/invoice-aggregations/${invoiceAggregationNumber}`,
    ).withObjectResponse();
  },
  fetchById: (id: string): Promise<InvoiceAggregationDetailsResponse> => {
    return wrappedApiGet<InvoiceAggregationDetailsResponse>(`/invoice-aggregations/${id}`).withObjectResponse();
  },
  actions: {
    sendCopy: ({ invoiceAggregationNumber }: { invoiceAggregationNumber: number }): Promise<void> => {
      return wrappedApiPut(`/invoice-aggregations/${invoiceAggregationNumber}/send`, {}).withEmptyResponse();
    },
    sendReminder: ({
      invoiceAggregationNumber,
      deliveryType,
    }: {
      invoiceAggregationNumber: number;
      deliveryType: DeliveryType;
    }): Promise<void> => {
      return wrappedApiPut(`/invoice-aggregations/${invoiceAggregationNumber}/reminders`, {
        body: { deliveryType },
      }).withEmptyResponse();
    },
    cancelReminders: ({ invoiceAggregationNumber }: { invoiceAggregationNumber: number }): Promise<void> => {
      return wrappedApiPut(
        `/invoice-aggregations/${invoiceAggregationNumber}/reminders/cancel`,
        {},
      ).withEmptyResponse();
    },
    markAsManuallyPaid: ({
      invoiceAggregationNumber,
      externalReference,
      bookingDate,
    }: {
      invoiceAggregationNumber: number;
      bookingDate: string;
      externalReference?: string;
    }): Promise<void> => {
      return wrappedApiPut(`/invoice-aggregations/${invoiceAggregationNumber}/mark-as-manually-paid`, {
        body: { externalReference, bookingDate },
      }).withEmptyResponse();
    },
  },
};
